import { render, staticRenderFns } from "./RoundResults.vue?vue&type=template&id=33c71038&scoped=true"
import script from "./RoundResults.vue?vue&type=script&lang=ts"
export * from "./RoundResults.vue?vue&type=script&lang=ts"
import style0 from "./RoundResults.vue?vue&type=style&index=0&id=33c71038&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c71038",
  null
  
)

export default component.exports